class productMedia extends HTMLElement {
  constructor() {
    super();
    const thumbnails = this.querySelectorAll('.media-thumb');
    const slider = this.querySelector('.product-media');
    const container = this.closest('[data-product]');
    console.log(container, 'container');

    slider.addEventListener('sliderMade', () => {
      const flkty = Flickity.data(slider);
      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', function (event) {
          console.log(event, 'EVENT');
          const selectedSlide = thumb.dataset.index;
          flkty.select(selectedSlide - 1);
        });
      });
    });

    container.addEventListener('variantchange', (event) => { 
      const variantData = JSON.parse(
        container.querySelector('[data-product-json]').textContent
      );
      const newVariantId = container.querySelector('[name="id"]').value;

      const selectedVariantArray = Object.values(variantData.variants).filter(
        (obj) => obj.id == newVariantId
      );
      const selectedVariant = selectedVariantArray[0];
      if (selectedVariant.featured_media) {
        const imageIndex = selectedVariant.featured_media.position;
        const flkty = Flickity.data(slider);
        flkty.select(imageIndex - 1);
      }
    });
  }
}
customElements.define('product-media', productMedia);
